/** Normalize plan.socialLogins from auth or API payloads. */
export const normalizePlanSocialLogins = (raw = {}) => ({
  google: raw?.google === true,
  apple: raw?.apple === true,
})

/** True when the tenant plan allows at least one social login provider. */
export const hasPlanSocialLoginAccess = (planSocialLogins = {}) => {
  const normalized = normalizePlanSocialLogins(planSocialLogins)
  return normalized.google || normalized.apple
}
